module.exports = __webpack_public_path__ + "img/cww_10.05781201.jpg";